import { __awaiter } from "tslib";
import { logger } from '@lusha/client-logger';
import { createOrUpdateEnrollment, getEnrollments, getUserActivity, submitContactsActivity, submitUserFeedback, } from '../../API/userActivityApi';
import browserDetails from '../../utils/detectBrowser';
import { actions } from './reducer';
const RATE_MODAL_DELAY = 3000;
class Dispatcher {
    constructor() {
        this.actions = actions;
    }
    fetchEnrollments() {
        return (dispatch) => __awaiter(this, void 0, void 0, function* () {
            dispatch(actions.enrollmentsFetchStarted());
            try {
                const data = yield getEnrollments();
                dispatch(actions.enrollmentsFetchSucceeded((data === null || data === void 0 ? void 0 : data.enrollments) || []));
            }
            catch (error) {
                logger.warn('Failed to fetch enrollments:', error);
                dispatch(actions.enrollmentsFetchFailed());
            }
        });
    }
    /** Rethrows on failure so the caller can tell a submitted action from a failed one. */
    submitEnrollment(payload) {
        return (dispatch) => __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield createOrUpdateEnrollment(payload);
                if (response === null || response === void 0 ? void 0 : response.id) {
                    dispatch(actions.upsertEnrollment(response));
                }
                return response;
            }
            catch (error) {
                logger.warn('Failed to submit enrollment:', error);
                throw error;
            }
        });
    }
    fetchUserActivity() {
        return (dispatch) => __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield getUserActivity();
                dispatch(actions.setActivity(data));
            }
            catch (error) {
                logger.warn('Failed to fetch user activity:', error);
            }
        });
    }
    submitFeedback({ starRating, feedbackText, storeRedirected = false, dismissalType = 'soft', }) {
        return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            try {
                const extensionVersion = getState().settings.version || null;
                const browserType = (browserDetails === null || browserDetails === void 0 ? void 0 : browserDetails.browser) || null;
                const subscriptionTier = (_b = (_a = getState().user.billing) === null || _a === void 0 ? void 0 : _a.category) !== null && _b !== void 0 ? _b : '';
                const feedbackData = {
                    extensionVersion,
                    browserType,
                    starRating,
                    feedbackText: feedbackText || null,
                    triggerAction: getState().userActivity.currentTriggerAction,
                    storeRedirected,
                    dismissalType,
                    subscriptionTier,
                };
                const response = yield submitUserFeedback(feedbackData);
                dispatch(actions.setLatestFeedback(response || null));
                return response;
            }
            catch (error) {
                logger.warn('Failed to submit feedback:', error);
                throw error;
            }
        });
    }
    checkAndShowRateModal(triggerAction) {
        return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
            try {
                if (getState().userActivity.isModalVisible)
                    return;
                yield dispatch(this.fetchUserActivity());
                dispatch(actions.setCurrentTriggerAction(triggerAction));
                if (getState().userActivity.showRatePopup) {
                    setTimeout(() => {
                        dispatch(actions.setModalVisible(true));
                    }, RATE_MODAL_DELAY);
                }
            }
            catch (error) {
                logger.warn('Failed to check rate modal:', error);
            }
        });
    }
    reportContactsRevealed({ action, contacts }) {
        return () => __awaiter(this, void 0, void 0, function* () {
            if (!action || !(contacts === null || contacts === void 0 ? void 0 : contacts.length))
                return;
            try {
                yield submitContactsActivity({ action, contacts });
            }
            catch (error) {
                logger.warn('Failed to report contacts revealed', error);
            }
        });
    }
    handleStoreRedirect() {
        return (dispatch) => __awaiter(this, void 0, void 0, function* () {
            try {
                yield dispatch(this.submitFeedback({ starRating: 5, storeRedirected: true, dismissalType: null }));
            }
            catch (error) {
                logger.warn('Failed to submit store redirect:', error);
            }
            dispatch(actions.setModalVisible(false));
            dispatch(actions.setCurrentRate(null));
        });
    }
    handleFeedbackSubmit(feedbackText) {
        return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
            let data;
            try {
                data = yield dispatch(this.submitFeedback({
                    starRating: getState().userActivity.currentRate || null,
                    feedbackText,
                    dismissalType: null,
                }));
            }
            catch (error) {
                logger.warn('Failed to submit feedback:', error);
            }
            dispatch(actions.setModalVisible(false));
            dispatch(actions.setCurrentRate(null));
            return data;
        });
    }
    handleSkip() {
        return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
            try {
                yield dispatch(this.submitFeedback({ starRating: getState().userActivity.currentRate || null, dismissalType: 'soft' }));
            }
            catch (error) {
                logger.warn('Failed to submit skip:', error);
            }
            dispatch(actions.setModalVisible(false));
            dispatch(actions.setCurrentRate(null));
        });
    }
    handleModalClose() {
        return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
            const { currentRate } = getState().userActivity;
            try {
                yield dispatch(this.submitFeedback({
                    starRating: currentRate || null,
                    dismissalType: currentRate ? 'soft' : 'hard',
                }));
            }
            catch (error) {
                logger.warn('Failed to submit dismissal:', error);
            }
            dispatch(actions.setModalVisible(false));
            dispatch(actions.setCurrentRate(null));
        });
    }
}
const UserActivityDispatcher = new Dispatcher();
export default UserActivityDispatcher;
